import { render, staticRenderFns } from "./renzhengjianyanLegislation.vue?vue&type=template&id=5328fe04&scoped=true"
import script from "./renzhengjianyanLegislation.vue?vue&type=script&lang=js"
export * from "./renzhengjianyanLegislation.vue?vue&type=script&lang=js"
import style0 from "./renzhengjianyanLegislation.vue?vue&type=style&index=0&id=5328fe04&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5328fe04",
  null
  
)

export default component.exports